import { defineStore } from 'pinia'
import {
  getCommunicationSidepaneHeight,
  getMainSubheaderHeight,
  getSecondarySubheaderHeight,
  getStickyHeaderHeight,
  getSystemBannerHeight,
} from '@app/utils/domHelpers'
import { ref } from 'vue'

export const useHeightStore = defineStore('height-store', () => {
  const stickyHeaderHeight = ref<string>(getStickyHeaderHeight())
  const mainSubheaderHeight = ref<string>(getMainSubheaderHeight())
  const secondarySubheaderHeight = ref<string>(getSecondarySubheaderHeight())
  const systemBannerHeight = ref<string>(getSystemBannerHeight())
  const communicationSidepaneHeight = ref<string>(
    getCommunicationSidepaneHeight()
  )

  function updateHeights(): void {
    stickyHeaderHeight.value = getStickyHeaderHeight()
    mainSubheaderHeight.value = getMainSubheaderHeight()
    secondarySubheaderHeight.value = getSecondarySubheaderHeight()
    systemBannerHeight.value = getSystemBannerHeight()
    communicationSidepaneHeight.value = getCommunicationSidepaneHeight()
  }

  return {
    updateHeights,
    stickyHeaderHeight,
    mainSubheaderHeight,
    secondarySubheaderHeight,
    systemBannerHeight,
    communicationSidepaneHeight,
  }
})
